/* @ngInject */
function brandFontsService ($rootScope, FontsBaseService, ConnectorWebService, CONSTANTS, Utils, ToastService, UploadService) {
  // Regex to check file extension to .ttf and .otf
  const _fontFileExtensions = /\.(ttf|otf)$/i

  const service = {
    uploadFont,
    updateFont,
    deleteFont,
    downloadFont,
    createNewFontConfiguration,
    updateFontConfiguration,
    removeFontFileExtension,
    isValidFileFormat,
    bulkDeleteBrandSectionFont
  }
  return angular.extend({}, FontsBaseService, service)

  function uploadFont (fonts, successCallback, onProgress, fontFields, showProgress, onError) {
    const options = {
      simultaneousLimit: 5
    }

    if (showProgress) {
      options.allFiles = $rootScope.uploadingFiles
    }

    const callbacks = {
      fnSuccess: successCallback,
      fnError: onError || ToastService.defaultErrorToast,
      fnProgress: onProgress
    }

    return UploadService.uploadWithCustomProgress(
      CONSTANTS.URL_FONTS,
      fonts,
      callbacks,
      options,
      fontFields
    )
  }

  function updateFont (fontId, font) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_FONTS_ID, [fontId])
    return ConnectorWebService.put(sUrl, font)
  }

  function deleteFont (sId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_FONTS_ID, [sId])
    return ConnectorWebService.fnDelete(sUrl)
  }

  function downloadFont (asset) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_FONTS_ID_DOWNLOAD, [asset.id])
    Utils.downloadFile(url)
  }

  function createNewFontConfiguration (data) {
    return ConnectorWebService.post(CONSTANTS.URL_CUSTOMER_FONT_CONFIGURATION, data)
  }

  function updateFontConfiguration (data) {
    return ConnectorWebService.put(CONSTANTS.URL_CUSTOMER_FONT_CONFIGURATION, data)
  }

  function removeFontFileExtension (fileName) {
    return fileName.replace(_fontFileExtensions, '')
  }

  function isValidFileFormat (fileName) {
    return _fontFileExtensions.test(fileName)
  }

  function bulkDeleteBrandSectionFont (fontsId) {
    return ConnectorWebService.put(CONSTANTS.URL_FONTS_BATCH_DELETE, fontsId)
  }
}

export { brandFontsService }
